import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService } from 'src/app/common/services/message.service';
import { LocalStorageService } from 'src/app/common/services/localStorage.service';
import { ApiService } from 'src/app/common/services/api.service';
import { OrderRightComponent } from '../../components/order-right/order-right.component';
import { CROSS } from 'src/defaultImages.js';

@Component({
  selector: 'app-complete-order-prompt',
  templateUrl: './complete-order-prompt.component.html',
  styleUrls: ['./complete-order-prompt.component.css'],
})
export class CompleteOrderPromptComponent implements OnInit {
  images = {
    CROSS,
  };
  orderId: string;
  errorMsg: string;
  isLoading: boolean = false;

  constructor(
    private _dialogRef: MatDialogRef<OrderRightComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    private _localStorage: LocalStorageService,
    private _msgService: MessageService,
    private _apiService: ApiService
  ) {}

  ngOnInit(): void {
    this.orderId = (this.data || {}).order_id;
    this.errorMsg = (this.data || {}).error_msg;
  }

  cancelClicked(): void {
    this.dismissModal({ data: null, success: 0, message: 'closed' });
  }

  completeOrder(): void {
    const formData: any = new FormData();
    formData.append('token', this._localStorage.get('token'));
    formData.append('order_id', this.orderId);
    formData.append('force', '1');

    this.isLoading = true;
    this._apiService.completeOrder(formData).subscribe(
      (res: any = {}) => {
        this.isLoading = false;
        if (res.status === 1) {
          this._msgService.showSuccess(res.message);
          this.dismissModal({
            data: null,
            success: 1,
            message: 'complete_confirmed',
          });
        } else if (res.status === 0) {
          this.errorMsg = res.message;
        } else {
          this.errorMsg = '';
        }
      },
      (error) => {
        this.isLoading = false;
        this._msgService.showSuccess(((error || {}).error || {}).message);
      }
    );
  }

  private dismissModal(data?): void {
    this._dialogRef.close(data);
  }
}
